<template>
    <v-card class="my-2">
        <v-card-title :class="!$breakpoint.smAndDown ? 'title' : 'subtitle-2'" class="pa-4 text-nobreak">
            {{ itineraryName }}
        </v-card-title>
        <v-card-text>
            <template v-for="(segment, segmentIndex) in itinerary.segments" :key="`itinerary-segment-${segmentIndex}`">
                <flight-segment-detail :segment="segment" />
                <div
                    v-if="itinerary.segments.length > 1 && segmentIndex !== itinerary.segments.length - 1"
                    class="my-2 px-5 py-3 d-flex flex-wrap flex-column flex-md-row align-center waiting-block"
                >
                    <div class="text-no-wrap">
                        {{ $filters.durationFormat(connectionDuration(segment, itinerary.segments[segmentIndex + 1])) }}
                    </div>
                    <div class="ml-0 ml-md-10">
                        {{ $t('flights.conneсt_in_airport') }}
                    </div>
                    <div class="ml-0 ml-md-10">
                        <strong v-if="connectionDuration(segment, itinerary.segments[segmentIndex + 1]) > 180">
                            {{ $t('flights.long_wait') }}
                        </strong>
                    </div>
                </div>
            </template>
        </v-card-text>
        <v-card-actions>
            <div v-if="itinerary.duration" class="text-subtitle-2">
                {{ $t('flights.total_trip_time') }}: {{ $filters.durationFormat(itinerary.duration) }}
            </div>
        </v-card-actions>
        <slot />
    </v-card>
</template>

<script lang="ts">
    import {Component, Prop, Vue} from 'vue-facing-decorator'
    import FlightSegmentDetail from '~/components/flights/search/offers/FlightSegmentDetail.vue'

    @Component({
        components: {
            FlightSegmentDetail,
        },
    })
    export class FlightItineraryDetail extends Vue {
        @Prop() itinerary

        connectionDuration({arrivalDate}, {departureDate}) {
            return this.$dateFns.differenceInMinutes(
                this.$dateFns.parseISO(departureDate),
                this.$dateFns.parseISO(arrivalDate)
            )
        }

        get itineraryName() {
            const firstSegment = this.itinerary.segments[0]
            const lastSegment = this.itinerary.segments[this.itinerary.segments.length - 1]
            return `${firstSegment.departureAirportDescription.airportName}, ${firstSegment.departureAirportDescription.cityName}, ${firstSegment.departureAirportDescription.countryName} - ${lastSegment.arrivalAirportDescription.airportName}, ${lastSegment.arrivalAirportDescription.cityName}, ${lastSegment.arrivalAirportDescription.countryName}`
        }
    }

    export default FlightItineraryDetail
</script>

<style lang="scss">
    .waiting-block {
        display: flex;
        padding-top: 0.75rem;
        padding-bottom: 0.75rem;
        border-radius: 0.375rem;
        background: #f1f2f8;
        color: #d1435b;
    }
</style>
